export const createInversedColor = (color: THREE.Color): THREE.Color =>
    new THREE.Color(1 - color.r, 1 - color.g, 1 - color.b);
